import {useEffect, useState} from "react";
import '../../../static/css/home/reports.css';
import {AuthRedirectAdmins, PostJSON, ServerImage} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import {Link} from "react-router-dom";
import {ThinArrowLeft} from "../../../components/icons/material-icons";

interface reportInterface {
    nd: string,
    teacher: string,
    course: string,
    class: string,
    title: string,
    body: string,
    createdAt: string,
    img: string,
}

export const HomeReportsScreen = () => {
    const [list, setList] = useState<reportInterface[]>([]);
    const [loaded, setLoaded] = useState(false);
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/home/reports/list',
            {},
            false,
            (d: {
                result: string,
                reason: string,
                list: reportInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    return;
                }
                setList(d.list === null ? [] : d.list);
                setLoaded(true);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "گزارشات کلاسی | مدرسه هوشمند نهال";
        fetchList();
    }, []);
    return (
        <>
            <div>
                <div className="home-news-hero"
                     style={{background: 'linear-gradient(140deg,rgba(0,255,0,0.1),rgba(0,0,255,0.2)'}}>
                    <div className="container-big">
                        <h1 data-aos="fade-up" data-aos-duration={1000}>گزارشات کلاسی</h1>
                        <p  data-aos="fade-up" data-aos-duration={1000} data-aos-delay={100}>مشاهده نمایید در کلاس‌های مدرسه نهال چه می‌گذرد.</p>
                    </div>
                </div>
            </div>
            {
                loaded ?
                    <div className="home-reports-list"  data-aos="fade-in" data-aos-duration={1000} data-aos-delay={200}>
                        <div className="container">
                            <div className="row">
                                {
                                    list.map((n, i) =>
                                        <div className="col-lg-4" key={"JJ29fsssu3iDDDjvs_u3" + i}>
                                            <Link to={`/reports/view/${n.nd}`}
                                                  className="news-item">
                                                <i style={{backgroundImage: `url(${ServerImage(n.img, 500)})`}}/>
                                                <div>
                                                    <em>درس {n.course}</em>
                                                    <b>{n.title}</b>
                                                    <p className="max-lines-2">{n.body}</p>
                                                    <div>
                                                        <button>
                                                            <span>مشاهده</span>
                                                            <ThinArrowLeft/>
                                                        </button>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    )
                                }
                            </div>
                            {
                                list.length < 1 ?
                                    <div className="staff--not-found">
                                        <em style={{backgroundImage: 'url(/svg/news.svg)'}}/>
                                        <b>گزارشی یافت نشد</b>
                                        <p>در حال حاضر، گزارشی برای نمایش موجود نیست.</p>
                                    </div> : null
                            }
                        </div>
                    </div> : null
            }
        </>
    );
};